import {MitulaSerpPageData} from "../SerpPage";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {ShowGoogleOneTapRequestedEvent} from "../googleOneTap/events";
import {GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY} from "../cmpAdsManager/constants";
import {PostEvent} from "../../../../common/ts/core/http";
import tracking from "../../../../common/ts/core/tracking";

let eventBus: EventBus = EventBus.getInstance();

async function init(pageData: MitulaSerpPageData) {
    if ('serviceWorker' in navigator) {
        await navigator.serviceWorker.register('/sw.js');
        await checkPermissions(pageData);
    }
}

function isFromSafariBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    // @ts-ignore
    return (userAgent.indexOf('safari') !== -1 && 'safari' in window && 'pushNotification' in window.safari);
}

async function checkPermissions(pageData: MitulaSerpPageData) {
    if (isFromSafariBrowser()) {
        await handleSafariPermissions(pageData);
    } else if (isBrowserCompatibleWithWPN()) {
        await handlePermissions(pageData);
    }
}

async function handleSafariPermissions(pageData: MitulaSerpPageData) {
    // @ts-ignore
    const permissionData = window.safari.pushNotification.permission('web.com.mitula.homes');
    if (permissionData.permission === 'default') {
        // @ts-ignore
        window.safari.pushNotification.requestPermission(
            'https://www.mitula.com/',
            'web.com.mitula.homes',
            {},
            handleSafariPermissions
        );
    } else if (permissionData.permission === 'denied') {
        showGoogleOneTap();
    } else if (permissionData.permission === 'granted') {
        await checkSubscribeToWPN(pageData);
        showGoogleOneTap();
    }
}

async function handlePermissions(pageData: MitulaSerpPageData) {
    if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission();
        if (permission === 'denied') {
            eventBus.emit(new tracking.TrackAnalyticsEvent({ name: 'wpn-retention-block' }));
            showGoogleOneTap();
        } else {
            eventBus.emit(new tracking.TrackAnalyticsEvent({ name: 'wpn-retention-allow' }));
            showGoogleOneTap();
            await checkSubscribeToWPN(pageData);
        }
    } else if (Notification.permission === 'granted') {
        showGoogleOneTap();
        await checkSubscribeToWPN(pageData);
    } else if (Notification.permission === 'denied') {
        showGoogleOneTap();
    }
}

async function checkSubscribeToWPN(pageData: MitulaSerpPageData) {
    const swRegistration = await navigator.serviceWorker.ready;
    const subscription = await swRegistration.pushManager.getSubscription();
    if (!subscription) {
        await subscribeToWPN(pageData);
        return;
    }

    if (subscription) {
        await updateWPNList(subscription, pageData);
    }
}

async function updateWPNList(subscription: PushSubscription, pageData: MitulaSerpPageData) {
    const endpoint = subscription.endpoint;
    const key = subscription.getKey("p256dh");
    const auth = subscription.getKey("auth");

    if (endpoint && key && auth) {
        const body = {
            'what': pageData.search,
            'endpoint': endpoint,
            'auth': arrayBufferToBase64(auth),
            'key': arrayBufferToBase64(key),
            'action': '6',
        }

        eventBus.emit(new PostEvent({ url: "/servletGestionAlertas", body, formUrlencoded: true }));
    }
}

async function subscribeToWPN(pageData: MitulaSerpPageData) {
    const swRegistration = await navigator.serviceWorker.ready;
    const subscription = await swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array('BPmq6GEKK3iyoIZuXqAEmPMlukYdFTXm8NmqsQmQlxZA8Xb-RIj4uGVeIWSS3inXbpmxhvptfdHJSrILUW2o4CI'),
    });
    await updateWPNList(subscription, pageData);
}

const urlBase64ToUint8Array = (base64String: string) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};

const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer) => {
    return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(arrayBuffer))));
}

function showGoogleOneTap() {
    const hasCookiesAlreadyBeenDeclared = localStorage.getItem(GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY);
    if (hasCookiesAlreadyBeenDeclared) {
        eventBus.emit(new ShowGoogleOneTapRequestedEvent());
    }
}

function isBrowserCompatibleWithWPN(): boolean {
    return 'PushManager' in window && 'showNotification' in ServiceWorkerRegistration.prototype;
}

export default {
    init,
};
